import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MdButtonModule } from '@angular/material';
import { MdInputModule } from '@angular/material';
import { MaterialModule } from '@angular/material';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { MainComponent } from './main/main.component';
import { MenuItemComponent } from './menu/menu-item/menu-item.component';
import { MenuComponent } from './menu/menu.component';



@NgModule({
    declarations: [
       HeaderComponent, MainComponent, MenuComponent, MenuItemComponent,
    ],
    imports: [
        CommonModule, RouterModule, MdInputModule, MdButtonModule, MaterialModule,
        ],

    exports: [
        HeaderComponent, MainComponent, MenuComponent, MenuItemComponent,
    ],
})

export class CoreModule {
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/core/core.module.ts